import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';

import {PipesModule} from '@pipes/Pipes.module';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {ModalModule} from 'ngx-bootstrap/modal';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AngularMyDatePickerModule} from 'angular-mydatepicker';
import {TextMaskModule} from 'angular2-text-mask';
import {TranslateModule} from '@ngx-translate/core';

import {DxDataGridModule, DxTreeViewModule, DxListModule, DxContextMenuModule, DxPivotGridModule, DxAccordionModule} from 'devextreme-angular';
import {ComponentesModule} from '@componentes/Componentes.module';

import {AlumnoModalComponent} from './alumno/alumno.component';
import {ColaboradorModalComponent} from './colaborador/colaborador.component';
import { RelacionPreguntaComponent } from './relacionpregunta/relacionPregunta.component';
import { ColaboradorEvaluacionModalComponent } from './colaboradorevaluacion/colaboradorevaluacion.component';
import { AsignacionAlumnoModal } from './asignacionalumno/asignacionalumno.component';
import { EvaluacionComponent } from './evaluacion/evaluacion.component';
import {AlumnoComponent} from '../evaluacionpendiente/alumno/alumno.component';
import { pivotcomponent } from './pivot/pivot.component';
import { AcordionComponent } from './acordion/acordion.component';

@NgModule({
    imports:
        [
            CommonModule,
            AngularSvgIconModule.forRoot(),
            FormsModule,
            AngularMyDatePickerModule,
            ReactiveFormsModule,
            PipesModule,
            TextMaskModule,
            ModalModule,
            TranslateModule,
            DxDataGridModule,
            DxPivotGridModule,
            DxTreeViewModule,
            DxListModule,
            DxContextMenuModule,
            ComponentesModule,
            DxAccordionModule
        ],
    declarations:
        [
            AlumnoModalComponent,
            ColaboradorModalComponent,
            RelacionPreguntaComponent,
            ColaboradorEvaluacionModalComponent,
            AsignacionAlumnoModal,
            EvaluacionComponent,
            AlumnoComponent,
            pivotcomponent,
            AcordionComponent
        ],

    exports:
        [
            AlumnoModalComponent,
            ColaboradorModalComponent,
            RelacionPreguntaComponent,
            ColaboradorEvaluacionModalComponent,
            AsignacionAlumnoModal,
            EvaluacionComponent,
            AlumnoComponent,
            pivotcomponent,
            AcordionComponent
        ],
    entryComponents: [
        EvaluacionComponent,
        AlumnoComponent,
        pivotcomponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

export class GlobalModule {
}
